import { useContext, useEffect, useState } from "react";
import { POLL_INTERACTION } from "../../../../AppConstants/AnalyticsEventName";
import { POLL_STATES } from "../../../../AppConstants/PollStates";
import { AnalyticsContext } from "../../../../contexts/Analytics/AnalyticsContextProvider";
import { UserContext } from "../../../../contexts/UserContext/UserContextProvider";
import PollManager from "../../../../Managers/webinar/polls";
import PollResponseManager from "../../../../Managers/webinar/polls/pollresponse";
import QAManager from "../../../../Managers/webinar/qa";
import TabComponent from "../../../../components/TabsComponent";
import styles from "./index.module.scss";
import Polls from "./Polls";
import QnA from "./QnA";
import {
  POLL_SUBMIT_EVENT,
  SUB_TAB_CLICK_EVENT,
} from "../../../../Clevertap/EventNames.ts";
import {
  getSubtabData,
  getWebinarClickData,
} from "../../../../Clevertap/EventHandler.ts";

const PollsNQnA = (props) => {
  const { hidePoll = false, moderatedQNA = true } = props;
  const { ongoingagendaid } = props.details;
  const { user } = useContext(UserContext);
  const { addGAWithUserInfo, addCleverTapAnalytics } =
    useContext(AnalyticsContext);
  const [selectedTab, setSelectedTab] = useState(0);
  const [pollData, setPollData] = useState(null);
  const [pollAnswerredData, setPollAnswerredData] = useState({});
  const [QA, setQA] = useState(null);

  useEffect(() => {
    if (props.details.id) {
      getPoll();
      getQA();
    }
    return () => {
      PollManager._get.removePollListener();
      QAManager._get.removePollListener();
    };
  }, [props.details.id]);

  const getPoll = async () => {
    PollManager._get.attachPollListener(props.details.id, (data, err) => {
      if (err) {
        return;
      }

      let visiblePollData = [];
      if (data && data.length) {
        visiblePollData = data.filter(
          (item) => item.status !== POLL_STATES.hide
        ); //pass index also
      }
      if (props.setPollIndicator) {
        if (visiblePollData && visiblePollData.length) {
          props.setPollIndicator(true);
        } else {
          props.setPollIndicator(false);
        }
      }
      setPollData(visiblePollData);
      getAllPollAnsweredDataForCurrentUser(visiblePollData);
    });
  };

  const getQA = async () => {
    QAManager._get.attachQAListener(props.details.id, (data, err) => {
      if (err) {
        return;
      }
      setQA(data);
    });
  };

  const submitResponse = (pollData, option) => {
    return new Promise(async (res, rej) => {
      try {
        let obj = {
          userId: user.uid,
          pollId: pollData.id,
          webinarId: props.details.id,
          agendaId: ongoingagendaid || "",
          option: option,
        };
        addCleverTapAnalytics(POLL_SUBMIT_EVENT, {
          "Poll ID": pollData.id,
          "Poll Question": pollData.title,
          "Poll Response": option.value,
          ...getWebinarClickData(props.details),
        });
        await PollResponseManager._post.createResponse(obj);
        PollInteractionAnalytics(pollData.id, option.id);
        setPollAnswerredData((prev) => {
          return { ...prev, [pollData.id]: option };
        });
        res();
      } catch (error) {
        rej(error);
      }
    });
  };

  const getAllPollAnsweredDataForCurrentUser = async (data) => {
    if (data?.length > 0) {
      let _pollAnswerredData = {};
      for (let i = 0; i < data.length; i++) {
        let res = await checkIfAlreadyAnswered(data[i].id);
        _pollAnswerredData = {
          ..._pollAnswerredData,
          [data[i].id]: res,
        };
      }
      setPollAnswerredData(_pollAnswerredData);
    }
  };

  const checkIfAlreadyAnswered = (pollId) => {
    return new Promise(async (res, rej) => {
      try {
        const pollIds = Object.keys(pollAnswerredData);
        if (pollIds.indexOf(pollId) !== -1) {
          res(pollAnswerredData[pollId]);
        }
        const result = await PollResponseManager._get.getUserResponse(
          user.uid,
          pollId
        );
        if (result) {
          res(result);
        } else {
          res(null);
        }
      } catch (error) {
        rej(null);
      }
    });
  };

  let visibleQAData = null;
  if (QA) {
    visibleQAData = QA.filter(
      (item) => item.status === POLL_STATES.showQuestion
    ); //pass index also
  }

  const PollInteractionAnalytics = (pollId, optionId) => {
    if (ongoingagendaid) {
      addGAWithUserInfo(POLL_INTERACTION, {
        eventId: props.details.id,
        timelineId: ongoingagendaid,
        pollId,
        optionId,
      });
    } else {
      addGAWithUserInfo(POLL_INTERACTION, {
        eventId: props.details.id,
        pollId,
        optionId,
      });
    }
  };

  const TABS = [
    {
      label: "Q&A",
      childComponent: () => {
        return (
          <QnA
            ques={visibleQAData}
            webinarID={props.details.id}
            moderatedQNA={moderatedQNA}
            details={props.details}
          />
        );
      },
      hideTab: false,
    },
    {
      label: "Polls",
      childComponent: () => {
        return (
          <Polls
            data={pollData}
            pollAnswerredData={pollAnswerredData}
            submitResponse={submitResponse}
          />
        );
      },
      hideTab: hidePoll,
    },
  ];

  useEffect(() => {
    if (props?.showTabDirectly) {
      props.qnaToggle(true);
      const index = TABS.findIndex(
        (key) => key.label == props?.showTabDirectly
      );
      setSelectedTab(index);
    } else if (props.details.id) {
      setSelectedTab(0);
    }
  }, [props.details.id, props?.showTabDirectly]);

  useEffect(() => {
    if (props?.showTabDirectly) {
      props.qnaToggle(true);
    }
  }, [props?.showTabDirectly]);

  const closeModal = (value) => {
    props.qnaToggle(value);
    props?.setShowTabDirectly(value);
  };

  return (
    <TabComponent
      tabs={TABS}
      onChangeTab={(index) => {
        setSelectedTab(index);
        addCleverTapAnalytics(
          SUB_TAB_CLICK_EVENT,
          getSubtabData({
            Section: TABS[index].label,
            ...props.details,
          })
        );
      }}
      activeTab={selectedTab}
      customHeaderClass={styles.customTabHeader}
      customTabClass={styles.customTabClass}
      customTabsWrapper={styles.customTabsWrapper}
      closeComponent={closeModal}
      tabFontSize={"1.125rem"}
      resetTabs={true}
    />
  );
};

export default PollsNQnA;
